module.exports = __webpack_public_path__ + "static/media/pictogram-seatTypePremierOne.fa616c82.svg";